/* ── APRIL, APRIL — THEME JS ────────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', () => {

  // ── CART DRAWER ───────────────────────────────────────────────────────────────
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartClose = document.getElementById('cart-close');

  function openCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(t => t.addEventListener('click', openCart));
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // ── REFRESH CART ────────────────────────────────────────────────────────────────
  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        renderCartItems(cart);
      });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCartItems(cart) {
    const itemsEl = document.getElementById('cart-items');
    const footerEl = document.getElementById('cart-footer');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><div style="font-size:32px;margin-bottom:12px">🎀</div><p>Your bag is empty</p></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) {
      footerEl.style.display = 'block';
      footerEl.querySelector('[data-cart-total]').textContent = formatMoney(cart.total_price);
    }

    itemsEl.innerHTML = cart.items.map((item, i) => `
      <div class="cart-item" style="display:flex;gap:14px;margin-bottom:16px;padding:14px;background:#fdf6f9;border-radius:14px;">
        <img src="${item.image}" style="width:60px;height:60px;object-fit:cover;border-radius:10px;" alt="${item.title}" />
        <div style="flex:1;">
          <div style="font-size:14px;font-weight:600;color:#3d2030;margin-bottom:2px;">${item.product_title}</div>
          <div style="font-size:12px;color:#8a6070;">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div style="font-size:14px;color:#c06080;font-weight:700;margin-top:4px;">${formatMoney(item.price)}</div>
        </div>
        <button data-remove-key="${item.key}" style="background:none;border:none;color:#c0a0b0;font-size:18px;cursor:pointer;align-self:flex-start;">×</button>
      </div>
    `).join('');

    itemsEl.querySelectorAll('[data-remove-key]').forEach(btn => {
      btn.addEventListener('click', () => removeItem(btn.dataset.removeKey));
    });
  }

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(() => refreshCart());
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ── ADD TO CART ────────────────────────────────────────────────────────────────
  document.querySelectorAll('[data-add-to-cart-form]').forEach(form => {
    const sizeButtons = form.querySelectorAll('.size-btn');
    const addBtn = form.querySelector('[data-add-to-cart-btn]');
    const variantInput = form.querySelector('[data-variant-id]');
    let selectedVariant = variantInput ? variantInput.value : null;
    sizeButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        sizeButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        selectedVariant = btn.dataset.variantId;
        if (variantInput) variantInput.value = selectedVariant;
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Cart ♡';
        }
      });
    });

    form.addEventListener('submit', e => {
      e.preventDefault();
      if (!selectedVariant) return;

      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedVariant, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        addBtn.textContent = '♡ Added to Cart';
        addBtn.classList.add('added');
        burstHearts(addBtn);
        refreshCart();
        setTimeout(() => {
          addBtn.textContent = 'Add to Cart ♡';
          addBtn.classList.remove('added');
          addBtn.disabled = false;
        }, 2000);
      });
    });
  });

  // ── HEART CONFETTI ─────────────────────────────────────────────────────────
  function burstHearts(originEl) {
    const rect = originEl.getBoundingClientRect();
    const colors = ['#f07090', '#ffb6d9', '#c06080'];
    for (let i = 0; i < 8; i++) {
      const heart = document.createElement('span');
      heart.textContent = '♡';
      heart.style.position = 'fixed';
      heart.style.left = (rect.left + rect.width / 2) + 'px';
      heart.style.top = (rect.top + rect.height / 2) + 'px';
      heart.style.color = colors[i % colors.length];
      heart.style.fontSize = (14 + Math.random() * 14) + 'px';
      heart.style.pointerEvents = 'none';
      heart.style.zIndex = '9999';
      heart.style.transition = 'transform 0.8s ease-out, opacity 0.8s ease-out';
      document.body.appendChild(heart);
      const angle = (Math.PI * 2 * i) / 8;
      const distance = 60 + Math.random() * 40;
      const dx = Math.cos(angle) * distance;
      const dy = Math.sin(angle) * distance - 40;
      requestAnimationFrame(() => {
        heart.style.transform = `translate(${dx}px, ${dy}px) rotate(${Math.random() * 60 - 30}deg)`;
        heart.style.opacity = '0';
      });
      setTimeout(() => heart.remove(), 850);
    }
  }

  // ── MOBILE NAV ───────────────────────────────────────────────────────────────────
  const menuToggle = document.getElementById('menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  menuToggle?.addEventListener('click', () => {
    mobileMenu?.classList.toggle('open');
  });

  // ── INITIAL CART COUNT ──────────────────────────────────────────────────────
  refreshCart();
});
